import { Injectable } from '@angular/core';
import {HttpClient, HttpErrorResponse, HttpHeaders} from "@angular/common/http";
import {BehaviorSubject} from "rxjs/index";
import {
    ApiAddress,
    ApiClaimsHistory,
    ApiClaimsHistoryV1,
    ApiContractDataModel,
    ApiContractOption,
    ApiCoverageItems,
    ApiPhone
} from "../model/cchsApiContractData.model";
import {
    Balance,
    ContractOption,
    CoverageDetails,
    DashboardData,
    PaymentViewData,
    ProfileData,
    ServiceHistoryItem
} from "../model/cinchAppViewData.model";

import { NotificationsService } from "./notifications.service";
import { ContractInfo } from '../model/contractInfo.modal';
import { tap } from "rxjs/operators";
import {environment} from "../../../environments/environment";



@Injectable({
  providedIn: 'root'
})



/**
 *   Fetch CinchDataService Class:
 *
 *   feed and observable subject after retriving the Contract information,
 *   it work on test and production
 *
 *   Input:
 *
 *   output:
 *      - usersData$
 *      - userData$
 *      - authUser$
 *      - navsData$
 *      - contractData$
 *      - claimsData$
 *      - notification$
 *      - navs$
 *      - nav$
 *
 *
 *   Methods:
 *     HTTP-API-Access:
 *      - fetchUsersData
 *      - fetchUserData
 *      - fetchContractData
 *      - fetchClaimsData
 *      - authUser
 *      - fetchNavsData
 *      - fetchNavData
 *     Format Data:
 *      - getStatusOfContract
 *      - getClaimHistoryOnFormatV1
 *      - getClaimHistoryOnFormat (Api is been rewrite)
 *      - getDashboardViewOnFormat
 *
 * **/
export class CinchDataService {

  // Observables and subscribers:
  usersData$ = new BehaviorSubject<any>( {} ); //subscribe to get the actual rep DATA
  userData$ = new BehaviorSubject<any>( {} ); //subscribe to get the actual rep DATA
  authUser$ = new BehaviorSubject<any>( {} ); //subscribe to get the actual posts DATA
  navsData$ = new BehaviorSubject<any>( {} ); //subscribe to get the actual Navs DATA
  contractData$ = new BehaviorSubject<ApiContractDataModel>( {}); //subscribe to get the actual contracts DATA
  claimsData$ = new BehaviorSubject<ApiClaimsHistory[] | ApiClaimsHistoryV1[]>( [] ); //subscribe to get the actual history claims DATA
  notification$ = new BehaviorSubject<any>( {} ); //subscribe to get the actual history claims DATA
  navs$ = new BehaviorSubject<any>( {} ); //subscribe to get navs Ids
  nav$ = new BehaviorSubject<any>( {} ); //subscribe to get a nav

  dashboardData$: BehaviorSubject<DashboardData> = new BehaviorSubject<DashboardData>( {} ); //subscribe to get a nav
  contractSearchData$ = new BehaviorSubject<any>( {} );

  httpSub;

  // internal Variables:
  _token = "";
  testSub ="";
  prodSub = "";
  _sub = "";
  _contractID = "";
  _navsData$ = {};
  _notification = {};
  _dashboardData: DashboardData = {};
  testApiUserUrl = "/t-api";
  prodApiUserUrl= environment.apiUriPrefix + "/api";
  apiUserUrl;

  // Status flags:
  testSwitch: boolean = false; // true or false
  testMode: boolean = false; // true or false
  multicontractMode: boolean = true; // true or false

  constructor( private http: HttpClient,
               private notificationMsg: NotificationsService) {

      this.apiUserUrl = this.prodApiUserUrl;
      // Events handler from service
      this.notification$.subscribe(notification => {
          console.log("DashboardComponent notification$", notification)
      }, e => console.log());

  }

  // HTTP Methods and fetch:

  /**
   *   Fetch Users Data:
   *
   *   this is meant to be used on admin model or test mode to switch between
   *   users from the test array.
   *
   *   Input: void
   *   output: Observable <any>
   *      - usersData$: all the users available as a array.
   *      - notification$: return notification array type to be used on the implemented view or component.
   *      - _notification: use in an internal array that keep all the notification by type
   *
   * **/
  fetchUsersData() {
        //this is only on test mode.
      if (this.testMode){
        const url =  this.testApiUserUrl + "/users/";
        this.httpSub = this.http.get<any>( url )
            .subscribe(data => {
            //    console.log("fetchUsersData data: ", data);
                this.usersData$.next(data);
            }, (err: HttpErrorResponse) => {
                if (err.error instanceof Error) {
                    console.log("fetchUsersData Error Client-side error occurred.");
                } else {
                    let errMsg = "fetchUsersData Error Server-side error occurred."+ err.message.toString();
                    console.log("fetchUsersData errMsg:", errMsg);
                    this._notification["fetchUsersData"] = {error: errMsg }
                    this.notification$.next(this._notification);
                }
                return { "error": err.error };
            });
      }
    }

    /**
     *   Fetch User Data:
     *
     *   feed and observable subject after retriving the user information,
     *   it work on test and production
     *
     *   Input:
     *      - sub:  this is the user identifier on produtcion this is the SUB code returned by the cognito auth protocol,
     *      on test we use the email as sub.
     *   output: Observable <any>
     *      - userData$: return an user profile type
     *      - notification$: return notification array type to be used on the implemented view or component.
     *      - _notification: use in an internal array that keep all the notification by type
     *
     *   TODO: define user profile type.
     *
     * **/
    fetchUserData(sub) {
        const url =  `${this.apiUserUrl}/${sub}/profile`;
        this.httpSub = this.http.get<any>( url )
            .subscribe(data => {
              //  console.log("fetchUserData data: ", data);

                // update the contract and history claims first contract.
                if ((data) && (data.contracts) && (data.contracts[0])) {
                    this.fetchContractData(data.contracts[0], sub);
                }

                this.userData$.next(data);
            }, (err: HttpErrorResponse) => {
                if (err.error instanceof Error) {
                    console.log("fetchUserData Error Client-side error occurred.");
                } else {
                    let errMsg = "fetchUserData Error Server-side error occurred."+ err.message.toString();
                    console.log("fetchUserData errMsg:", errMsg);
                    this._notification["fetchUserData"] = {error: errMsg }
                    this.notification$.next(this._notification);
                }
                return { "error": err.error };
            });
    }

    /**
     *   Fetch Contract Data:
     *
     *   feed and observable subject after retriving the Contract information,
     *   it work on test and production
     *
     *   Input:
     *      - sub:  this is the user identifier on produtcion this is the SUB code returned by the cognito auth protocol,
     *      on test we use the email as sub.
     *      - contractNumber: a valid contract ID, you cna find this on the user profile as array,
     *      the application takes the first id of the array as default.
     *   output: Observable <any>
     *      - contractData$: return an contract type
     *      - notification$: return notification array type to be used on the implemented view or component.
     *      - _notification: use in an internal array that keep all the notification by type
     *
     *
     * **/
    fetchContractData( contractNumber,  sub? ) {
        sub = (sub)? sub : this._sub;
        const url = `${this.apiUserUrl}/${sub}/contracts/${contractNumber}/dashboard`;
        this.httpSub = this.http.get<ApiContractDataModel>( url )
            .subscribe(contract => {


                // cleaning initial values.
                this._dashboardData = {};
                this.notificationMsg.clearAllAlerts();

                // add fetching contract
                if (contract && contract.balanceInfo) {
                    this.fetchClaimsData(contractNumber, sub);
                    this._dashboardData = this.getDashboardViewOnFormat(contract);
                    this.ShowingNotificationOfContract(contract);
                    //console.log("fetchContractData data: ", {  contract: contract, _dashboardData: this._dashboardData});
                }
                this.contractData$.next(contract);

            }, (err: HttpErrorResponse) => {
                if (err.error instanceof Error) {
                    console.log("fetchContractData Error Client-side error occurred.");
                } else {
                    let errMsg = "fetchContractData Error Server-side error occurred."+ err.message.toString();
                    console.log("fetchContractData errMsg:", errMsg);
                    this._notification["fetchContractData"] = {error: errMsg }
                    this.notification$.next(this._notification);
                }
                return { "error": err.error };
            });
    }

    /**
     *   Fetch Claims Data:
     *
     *   feed and observable subject after retriving the Claims information,
     *   it work on test and production
     *
     *   Input:
     *      - sub:  this is the user identifier on produtcion this is the SUB code returned by the cognito auth protocol,
     *      on test we use the email as sub.
     *      - contractNumber: a valid contract ID, you cna find this on the user profile as array,
     *      the application takes the first id of the array as default.
     *   output: Observable <any>
     *      - claimsData$: return an user claims history array type
     *      - notification$: return notification array type to be used on the implemented view or component.
     *      - _notification: use in an internal array that keep all the notification by type
     *
     *
     * **/
    fetchClaimsData( contractNumber,  sub? )  {

        sub = (sub)? sub : this._sub;
        const url = `${this.apiUserUrl}/${sub}/contracts/${contractNumber}/claims`;
        this.httpSub = this.http.get<any>( url )
            .subscribe(claims => {
            //    console.log("fetchClaimsData data: ", data);
                if (claims) {
                    this.claimsData$.next(claims);
                    if (this._dashboardData && this._dashboardData.balance) {
                        if (claims.length > 0) {
                            this._dashboardData.serviceHistory = (this.testMode) ?
                                this.getClaimHistoryOnFormatV1(<ApiClaimsHistoryV1[]>claims) :
                                this.getClaimHistoryOnFormat(<ApiClaimsHistory[]>claims);
                        }
                        this.dashboardData$.next(this._dashboardData);
                    }
                } else if (this._dashboardData) this.dashboardData$.next(this._dashboardData);

            }, (err: HttpErrorResponse) => {
                if (err.error instanceof Error) {
                    console.log("fetchClaimsData Error Client-side error occurred.");
                } else {
                    let errMsg = "fetchClaimsData Error Server-side error occurred."+ err.message.toString();
                    console.log("fetchClaimsData errMsg:", errMsg);
                    this._notification["fetchClaimsData"] = {error: errMsg }
                    this.notification$.next(this._notification);
                }
                return { "error": err.error };
            });
    }

    /**
     *   Auth User:
     *
     *   simulate an authentication login,
     *   it work on test only
     *
     *   Input:
     *      - userID:  this is the user identifier on produtcion this is the SUB code returned by the cognito auth protocol,
     *      on test we use the email as sub.
     *      - pass: a valid password for the test api.
     *   output: Observable <any>
     *      - authUser$: return an user profile type
     *      - notification$: return notification array type to be used on the implemented view or component.
     *      - _notification: use in an internal array that keep all the notification by type
     *
     * **/
    authUser( userID, pass ) {
        //this is only on test mode.

        let loginHeader = new HttpHeaders()
            .set("uid",userID)
            .set("pass",pass)
            .set("Content-Type","application/json");

        const url = `${this.apiUserUrl}/auth`;
        // Get Rep Data from ByD
        this.httpSub = this.http.post<any>( url, {} , {headers: loginHeader} )
            .subscribe(data => {
               // console.log("authUser data: ", data);
                if (data.status["error-code"] === 200) {
                  this.authUser$.next(data);
                  this._sub = data.email;
                 // console.log("token selected:", this._sub);
                } else {
                 // console.log("authUser status: ", data.status);
                    this._notification["authUser"] = data.status
                    this.notification$.next(this._notification);
                }

            }, (err: HttpErrorResponse) => {
                if (err.error instanceof Error) {
                    console.log("authUser Error Client-side error occurred.");
                } else {
                    let errMsg = "authUser Error Server-side error occurred."+ err.message.toString();
                    console.log("authUser errMsg", errMsg);
                    this._notification["authUser"] = {error: errMsg }
                    this.notification$.next(this._notification);

                }
                return { "error": err.error };
            });
    }

    /**
     *   Fetch Navs Data:
     *
     *   return an array with nav ids
     *   it work on test only
     *
     *   Input: void
     *   output: Observable <any>
     *      - navs$: nav ids array.
     *      - notification$: return notification array type to be used on the implemented view or component.
     *      - _notification: use in an internal array that keep all the notification by type
     *
     * **/
    fetchNavsData() {
        let url = `${this.testApiUserUrl}/navs/`;
        this.httpSub = this.http.get<any>( url )
            .subscribe(data => {
               // console.log("fetchNavsData data: ", data);
                this.navs$.next(data.data);
            }, (err: HttpErrorResponse) => {
                if (err.error instanceof Error) {
                    console.log("fetchNavsData Error Client-side error occurred.");
                } else {
                    let errMsg = "fetchNavsData Error Server-side error occurred."+ err.message.toString();
                    console.log("fetchNavsData errMsg:", errMsg);
                    this._notification["fetchNavsData"] = {error: errMsg }
                    this.notification$.next(this._notification);
                }
                return { "error": err.error };
            });
    }

    /**
     *   Fetch Nav Data:
     *
     *   return an array with nav ids
     *   it work on test only
     *
     *   Input:
     *      - navID: a valid Nav id.
     *   output: Observable <any>
     *      - navs$: nav ids array.
     *      - notification$: return notification array type to be used on the implemented view or component.
     *      - _notification: use in an internal array that keep all the notification by type
     *
     * **/
    fetchNavData( navID ) {
        navID = (navID)? navID : "";
        let url = `${this.testApiUserUrl}/navs/${navID.toString()}` ;
        this.httpSub = this.http.get<any>( url )
            .subscribe(data => {
              //  console.log("fetchNavData data: ", data);
                this.nav$.next(data.data);
            }, (err: HttpErrorResponse) => {
                if (err.error instanceof Error) {
                    console.log("fetchNavData Error Client-side error occurred.");
                } else {
                    let errMsg = "fetchNavData Error Server-side error occurred."+ err.message.toString();
                    console.log("fetchNavData errMsg:", errMsg);
                    this._notification["fetchNavData"] = {error: errMsg }
                    this.notification$.next(this._notification);
                }
                return { "error": err.error };
            });
    }

    contractSearch(queryParameters) {

       let httpOptions = {
            headers: new HttpHeaders({
                'Content-Type':  'application/json',
                'Accept': 'application/json'
            }),
            params: queryParameters
        };

        return this.http.get<ContractInfo[]>( environment.apiUriPrefix + '/api/public/contracts', httpOptions)
            .pipe(
                tap(
                    data => {
                        console.log("contractSearch data: ", data);
                        //publish new data to contract search data, just in case someone is listening to this events.
                        this.contractSearchData$.next(data);
                    },
                    err => {
                        console.log("contractSearchData error:", err);
                        this._notification["contractSearchData"] = {error: err };
                        this.notification$.next(this._notification);
                    }
                )
            );
    }


    // Actions Methods

    toggleTestMode() {
        this.contractData$.next({});
        this.claimsData$.next([]);
        this.usersData$.next({});
        if (this.testMode) {
            this.testMode = false;
            this.apiUserUrl = this.prodApiUserUrl;
            this._sub= this.prodSub;
            this.fetchUserData(this.prodSub);
        } else {
            this.testMode = true;
            this.apiUserUrl = this.testApiUserUrl;
            this._sub= this.testSub;
            this.fetchUsersData();

        }
        // console.log("toggleTestMode sets", {
        //     "_sub": this._sub,
        //     "apiUserUrl": this.apiUserUrl,
        //     "testMode": this.testMode,
        //     "testSub": this.testSub,
        //     "prodSub": this.prodSub
        // });
    }
    ShowingNotificationOfContract ( contract:ApiContractDataModel ){
        this.notificationMsg.clearAllAlerts();
        if ((contract.balanceInfo.pastDue || contract.userStatuses.PAYMENT_PENDING ) &&
            ((contract.userStatuses.CONTRACT_EXPIRED === false) ||
                (contract.userStatuses.CONTRACT_CANCELLED === false)))
            this.notificationMsg.showAlert("Payment is due", "","Pay now","myaccount/payments", "alert", "payment-due");
        if ((contract.userStatuses.PAYMENT_PENDING) &&
            (contract.userStatuses.CONTRACT_EXPIRED === false) &&
            (contract.userStatuses.CONTRACT_CANCELLED === false))
            this.notificationMsg.showAlert("Payment is pending", "","Pay now","myaccount/payments", "alert", "payment-pending");
        if (contract.userStatuses.CONTRACT_EXPIRED)
            this.notificationMsg.showAlert("Your contract is expired!", "","Renew your contract","myaccount/payments", "alert", "contract-expired");
        if (contract.userStatuses.CONTRACT_CANCELLED)
            this.notificationMsg.showAlert("Your contract is cancelled!", "","Renew your contract","myaccount/payments", "alert", "contract-cancel");
    }

    // Data format methods:

    // - Views
    getDashboardViewOnFormat( dashboard: ApiContractDataModel ): DashboardData {
        return  {
            // top contract info
            customerName : (dashboard.baseContract.primaryCustomer.firstName + " "+ dashboard.baseContract.primaryCustomer.lastName),
            companyName : dashboard.baseContract.primaryCustomer.companyName,
            planName: dashboard.baseContract.productName,
            planNumber: dashboard.baseContract.contractNumber,
            planStatus: this.getStatusOfContract(dashboard),
            planExpiration: this.getUnixDateFormYYYYmmdd(dashboard.baseContract.expirationDate), // date mm/dd/yyyy
            autoRenew_flag: dashboard.userStatuses.AUTO_RENEW,
            autoRenew: (( dashboard.userStatuses.AUTO_RENEW) ? "on" : "off" ),

            // current balance section
            showCurrentBalance: ((dashboard.userStatuses.IS_FINANCIAL_CHANNEL) ? false : true ), // false if financial channel customer
            balance: this.getBalanceOnFormat( dashboard ),
            showEditDetailsBtn: (( dashboard.userStatuses.CONTRACT_CANCELLED || dashboard.userStatuses.CONTRACT_EXPIRED ) ? false : true)
        };
    }
    getCoverageDetailsViewOnFormat(contract: ApiContractDataModel): CoverageDetails {
        return {
            nameOfPlan: contract.baseContract.productName,
            contractDocumentUrl: contract.coverageSummaryUrl,
            showCancelContractBtn: contract.userStatuses.IS_ONLINE_CALIFORNIA,
            planDetails: {
                contractNumber: contract.baseContract.contractNumber,
                planStatus: this.getStatusOfContract(contract),
                enrollmentDate: contract.baseContract.enrollmentDate,
                creationDate: contract.baseContract.creationDate,
                expirationDate: this.getUnixDateFormYYYYmmdd(contract.baseContract.expirationDate),
                effectiveDate: this.getUnixDateFormYYYYmmdd(contract.baseContract.effectiveDate),
                cancelDate: contract.baseContract.cancelDate
            },
            propertyInformation: {
                coveredProperty: this.addressToString( contract.baseContract.propertyAddress ),
                planHolder: this.addressToString( contract.billingAddress )
            },
            cost: {
                totalCostsMonth: this.priceRoudUp( ( contract.productBaseCoverage.productInfo.cost / 12 ) ),
                totalCostsYear: this.priceRoudUp( contract.productBaseCoverage.productInfo.cost ),
                deductible: this.priceRoudUp( contract.productBaseCoverage.productInfo.deductible )
            },
            coverage: this.getCoverageItemsOnFormat( contract.productBaseCoverage.baseItems ),
            contractOptions: this.getContractOptionsOnFormat( contract.contractOptions )

        };

    }
    getProfileViewOnFormat(contract: ApiContractDataModel ):ProfileData {
        return {
            propertyAddress: contract.baseContract.propertyAddress,
            callForUpdate: "+1 (800) 222-4444",
            mailingAddress: contract.billingAddress ,
            contactName: (contract.baseContract.primaryCustomer.firstName + " "+ contract.baseContract.primaryCustomer.lastName).toLowerCase(),
            contactEmail: contract.baseContract.primaryCustomerEmail,
            contactPhone:  this.getPhoneOnFormat(contract.baseContract.primaryCustomerPhone),
            password: "******"
        };
    }
    getPaymentsViewOnFormat(contract:ApiContractDataModel ): PaymentViewData {

        return {
            cost: {
                totalCostsMonth: this.priceRoudUp( ( contract.productBaseCoverage.productInfo.cost / 12 ) ),
                totalCostsYear: this.priceRoudUp( contract.productBaseCoverage.productInfo.cost ),
                deductible: this.priceRoudUp( contract.productBaseCoverage.productInfo.deductible )
            },
            balance: this.getBalanceOnFormat( contract ),
            paymentHistory: contract.paymentHistory,
            paymentInfo: contract.paymentInfo,
            isFinancialChannel: contract.userStatuses.IS_FINANCIAL_CHANNEL
        };
    }

    // - dataTypes
    //TODO: to be deprecated on 2 weeks
    getClaimHistoryOnFormatV1(claimHistory: ApiClaimsHistoryV1[] ): ServiceHistoryItem[] {
        let aux = [];

        claimHistory.map( (claim ) => {
            let initDate = claim.initiationDate;
            let serviceOrder = claim.claimNumber;
            if ((claim.items) && (claim.items.length > 0)){
                claim.items.map( (item)  => {
                    aux.push({
                        "requestDate": initDate,
                        "type": item.serviceRequestType,
                        "item": item.name,
                        "status": item.status,
                        "status_description": item.toolTip,
                        "service_order": serviceOrder,
                        "date_completed":item.appointmentDate
                    });
                });
            }
        });
        aux.sort((a, b) => b.requestDate - a.requestDate);

        return aux;
    }
    getClaimHistoryOnFormat(claimHistory: ApiClaimsHistory[] ): ServiceHistoryItem[] {
        let aux:ServiceHistoryItem[] = [];

        claimHistory.map( (claim ) => {
            let i: ServiceHistoryItem = {
                "requestDate": (new Date(claim.displayDay).getTime()),
                "type": "[Type]",
                "item": "[Item]",
                "status": claim.serviceJobStatus,
                "status_description": claim.serviceDescription,
                "service_order": claim.serviceOrderId,
                "date_completed": (new Date(claim.completionDate).getTime())
            }
            claim.models.map((item)=>{
                i.item = item.productLineDescription;
                aux.push(i);
            });
        });
        //  console.log("|---> cinch-data-service claim history aux:",aux);
        aux.sort((a, b) => b.requestDate - a.requestDate);

        return aux;
    }
    getCoverageItemsOnFormat( items: ApiCoverageItems[] ): string[] {
        return items.map(item => {return item.description.toLowerCase()});
    }
    getContractOptionsOnFormat( contractOptions: ApiContractOption[] ): ContractOption[] {
        return contractOptions.map(contractOption => {
            return {
                optionName: contractOption.itemDescription.toLowerCase(),
                optionCost: this.priceRoudUp( contractOption.totalCost ),
                optionID: contractOption.categoryId
            }
        });
    }
    getPhoneOnFormat( phone: ApiPhone): string {
      //  console.log("getPhoneOnFormat phone", phone);
        if (phone.phoneNumber){
            let out = "";
            //let out = (phone.areaCode && phone.areaCode != null)? "+" + phone.areaCode + " " : "";
            if (phone.areaCode) out = "+" + phone.areaCode +" ";
            out += this.phoneNumberFormat(phone.phoneNumber);
            if (phone.extention) out += ":" + phone.extention;
            return out;
        } return "";
    }
    getBalanceOnFormat( contract:ApiContractDataModel ): Balance {
        let status = "";
        let msg = "";
        let makeAPayment = false;
        let editPaymentInfo = false;
        let msgDate = 0;

        if ( contract.userStatuses &&
            contract.userStatuses.PAYMENT_PENDING){
            status = "Pending";
            msg = `Your payment is being processed.`;
        } else if (contract.balanceInfo &&
            contract.balanceInfo.pastDue){
            status = "Past Due";
            msg = `Your account is past due. Please make your payment now.`;
            makeAPayment = true;
        } else if (contract.balanceInfo &&
            contract.balanceInfo.chargeDate &&
            (contract.balanceInfo.balanceDue > 0 )) {
            msg = `Your next payment will be processed on:`;
            msgDate = contract.balanceInfo.dueDate;
            editPaymentInfo = true;
        } else if (contract.balanceInfo.balanceDue === 0 ){
            msg = `There is no amount due at this time.`;
            editPaymentInfo = true;
        } else {
            msg = `Your monthly charges have been paid.`;
            editPaymentInfo = true;
        }

        return {
            currentBalance: contract.balanceInfo.balanceDue,
            wilPayOn: contract.balanceInfo.chargeDate,
            autoPay_flag: contract.userStatuses.AUTO_PAYMENT,
            autoPay: (( contract.userStatuses.AUTO_PAYMENT) ? "on" : "off" ),
            dueDate: contract.balanceInfo.dueDate,
            status: status,
            message: msg,
            msgDate: msgDate,
            makeAPayment: makeAPayment,
            editPaymentInfo: editPaymentInfo,
        };
    }

    // - helpers
    getStatusOfContract( contract: ApiContractDataModel ) {
        if (contract.userStatuses.CONTRACT_EXPIRED){
            return "Expired";
        } else if (contract.userStatuses.CONTRACT_CANCELLED){
            return "Cancelled";
        } else if ((contract.userStatuses.CONTRACT_EXPIRED === false) &&
            (contract.userStatuses.CONTRACT_CANCELLED === false) &&
            (contract.userStatuses.CONTRACT_INACTIVE === false)){
            return "Active";
        } else if (contract.userStatuses.CONTRACT_INACTIVE){
            return "Inactive";
        } else {
            return "Unknown";
        }
    }
    addressToString ( address: ApiAddress ): string {
        let out = ((address.addressLine1)? address.addressLine1: "" );
        out = out + ((address.addressLine2)? (" " + address.addressLine2) : "");
        out = out + ((address.addressLine3)? (" " + address.addressLine3) : "");
        out = out + ((address.city)? (" " + address.city) : "" );
        out = out + ((address.state || address.zip)? "," : "" );
        out = out + ((address.state)? (" " + address.state) : "" );
        out = out + ((address.zip)? " " + address.zip : "");
        return out.toLowerCase();
    }
    priceRoudUp( money: number ): number {
        return Number((money).toFixed(2));
    }
    phoneNumberFormat( number: string | number  ){
        let s2 = ("" + number).replace(/\D/g, '');
        let m = s2.match(/^(\d{3})(\d{3})(\d{4})$/);
        return (!m) ? null : "(" + m[1] + ") " + m[2] + "-" + m[3];
    }
    getUnixDateFormYYYYmmdd( str ):string {
        const y = str.substr(0,4),
            m = str.substr(4,2) - 1,
            d = str.substr(6,2);
        let out: Date = new Date(y,m,d);
        return (out.getFullYear() == y && out.getMonth() == m && out.getDate() == d) ? out.getTime().toString() : '0';

    }

    /**
     *  paginateThisArray( items )
     *
     *  return a array with the bnumber of items selected to simulate pagination.
     *
     *  In:  p = page, a= amount of items, items = array of elements
     *  out: array.
     *
     *
     * **/
    paginateThisArray( items:[] , a: number, p?: number  ): [] {
        if (items.length > 0 ){
            if (items.length <= a ){
                return items;
            } else {
                let aux;
                for (let i; i <= a; i++ ){
                    aux[i] = items[i];
                }
                return aux;
            }
        }
    }








}
